var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isRecordKeeper)?_c('div',{staticClass:"text-center"},[_c('h1',[_vm._v(" Not authorized to create document templates. Please contact your business admin. ")])]):_c('div',[_c('DocumentBuilder',{attrs:{"editData":_vm.DEFAULT_TEMPLATE}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }